// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/info-gradient.svg';

export const InfoGradient = (props: SvgIconProps) => (
    <SvgIcon
        component={Svg}
        inheritViewBox
        style={{ width: 36, height: 35 }}
        {...props}
    />
);
